import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { Selector } from '@/components/UI';
import { SchedulePriority } from '@/types/rooms';
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        modelValue: null
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const value = ref(props.modelValue);
        watch(props, () => {
            value.value = props.modelValue;
        }, { deep: true });
        const update = () => {
            emits('update:modelValue', value.value);
        };
        const options = [
            { text: "Important", value: SchedulePriority.Important },
            { text: "Normal", value: SchedulePriority.Normal },
            { text: "Minor", value: SchedulePriority.Minor },
            { text: "Don't Schedule", value: SchedulePriority.Never }
        ];
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Selector), {
                options: options,
                modelValue: value.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event)),
                onChange: update
            }, null, 8, ["modelValue"]));
        };
    }
});
